import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=4f006642&scoped=true&"
import script from "./Rule.vue?vue&type=script&lang=js&"
export * from "./Rule.vue?vue&type=script&lang=js&"
import style0 from "./Rule.vue?vue&type=style&index=0&id=4f006642&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f006642",
  null
  
)

export default component.exports